var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseWhite = function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "data-name": "Group 465",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.379 17.379"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 101",
    d: "M14.834 2.546a8.687 8.687 0 0 0-12.288 0 8.687 8.687 0 0 0 0 12.288 8.687 8.687 0 0 0 12.288 0 8.687 8.687 0 0 0 0-12.288Zm-.72 11.568A7.671 7.671 0 1 1 3.265 3.265a7.671 7.671 0 0 1 10.849 10.849Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 102",
    d: "M12.522 11.799 9.409 8.69l3.109-3.109a.51.51 0 1 0-.72-.72L8.689 7.97 5.58 4.861a.51.51 0 0 0-.72.72L7.969 8.69 4.86 11.799a.506.506 0 0 0 0 .72.508.508 0 0 0 .72 0L8.689 9.41l3.109 3.109a.51.51 0 0 0 .723-.72Z",
    fill: "#fff"
  })))));
};
export default SvgCloseWhite;